import { render, staticRenderFns } from "./OrganizationWallet.vue?vue&type=template&id=2a65162e&"
import script from "./OrganizationWallet.vue?vue&type=script&lang=js&"
export * from "./OrganizationWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports